import styled from 'styled-components';
import { ScreenWidth } from 'web-common/src/shared/Constants';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';

export const DeliveryDateHeader = styled.div`
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 32px 0 16px;
`;

export const DeliveryDate = styled.h3`
  font-size: 24px;
  font-weight: bold;
  font-family: ${Font.Family.SANS};
  margin: 0;
`;

export const OrdersContainer = styled.div`
  margin-bottom: ${Spacing.SINGLE};
`;

export const DeliveryBannerContainer = styled.div`
  padding: ${Spacing.SINGLE_HALF};

  @media (max-width: ${ScreenWidth.SMALL}) {
    padding: ${Spacing.HALF} ${Spacing.SINGLE};
  }
`;

export const OrderBlocksContainer = styled.div`
  background: white;
  position: relative;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
`;

export const MultiCartTotalsContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid ${Colors.GRAY_LITE_20};
  box-shadow: 0px 2px 4px 1px ${Colors.GRAY_LITE_10};
`;
